module.exports = __webpack_public_path__ + "img/ss-4.072899c2.svg";